import React from 'react';
import moment from 'moment';
import { callAvailability } from '../../../services/transfersService';
const TRANSFER_SERVICE_DISTRIBUTION_FORMAT = 'YYYY-MM-DD HH:mm:ss';
/**
 * Este controller realiza el manejo de vistas de busqueda de transfers
 * y modifica el estado de esa vista (no el state o model de la propia vista).
 * 
 * Es un  MVC style pero sin el model totalmente decoupled.
 * 
 * @author Luciano Bustos
 */
class SearchTransferController extends React.PureComponent {
    constructor(props, view) {
        super(props);
        this.view = view;

        let from = new Date();
        from.setHours(8, 0);
        let to = new Date(new Date().getTime() + 86400000);
        to.setHours(8, 0);

        this.defaultState = {
            loading: this.props.loading || false,
            reservation: '',
            inputError: false,
            totalRooms: 1,
            fromDateTime: moment.utc(from),
            toDateTime: moment.utc(to),
            transferType: 'roundtrip',
            from: props.searchContentState ? props.searchContentState.from : null,
            to: props.searchContentState ? props.searchContentState.to : null,
            rooms: [
                {
                    adults: 2,
                    kids: [],
                }
            ]
        };
    }

    setStateFromQuery = (query, comp) => {
        if (query) {
            let sta = comp.state;
            let room = sta.rooms[0];
            room.kids = query.kids;
            room.adults = query.adults;

            sta.from = query.from;
            sta.to = query.to;
            sta.fromDateTime = query.fromDateTime;
            sta.toDateTime = query.toDateTime;
            sta.datePickerStatus = this.isAvailabilityTypeOneWay(query.transferType);
            sta.reservation = query.AssociatedOlympiaLocator;
            comp.setState(sta);
        }
    }

    getInitialState = () => {
        return this.defaultState;
    }

    __getQueryStringAsObj = (queryString) => {
        var obj = {};
        if (queryString.indexOf('?') === -1) {
            return obj;
        }
        queryString = queryString.substr(queryString.indexOf('?') + 1);
        var pairs = queryString.split('&');
        for (var i in pairs) {
            var split = pairs[i].split('=');
            obj[decodeURIComponent(split[0])] = decodeURIComponent(split[1]);
        }
        return obj;
    }


    getStateFromParams = () => {
        let state = this.view.state;
        let props = this.__getQueryStringAsObj(window.location.hash);
        if (props.adults) {
            state.rooms[0].adults = Math.min(45, parseInt(props.adults, 10));
        }
        if (props.kidsAges) {
            let kidos = props.kidsAges.split(',').map(k => { return { age: parseInt(k, 10) }; });
            state.rooms[0].kids = kidos;
        }
        if (props.from) {
            state.fromDateTime = moment(props.from, 'DD/MM/YYYY');
        }
        if (props.nights) {
            let toDate = moment(state.fromDateTime).add(props.nights || 1, 'days');
            state.toDateTime = toDate;
        }
        if (props.locator) {
            state.reservation = props.locator;
        }
        setTimeout(() => {
            this.view.setState(state);
        }, 500);
    }

    handleTransferTypeChange = event => {
        let state = this.view.state;
        state.transferType = event.target.value;
        state.datePickerStatus = this.isAvailabilityTypeOneWay(event.target.value);
        this.view.setState(state);

        //this.amendToDate(event.target.value, this.state.fromDateTime);
    };

    handleDateChange = (date) => {
        let hr = moment(this.view.state.fromDateTime).hour();
        let min = moment(this.view.state.fromDateTime).minutes();
        date.hours(hr);
        date.minutes(min);
        this.view.setState({
            fromDateTime: moment.utc(date)
        });

        this.amendToDate(this.view.state.transferType, date);
    };

    handleHourChange = (hour, minutes) => {
        const date = moment.utc(this.view.state.fromDateTime);
        date.hour(hour);
        date.minutes(minutes);
        this.view.setState({
            fromDateTime: moment.utc(date)
        });
    };

    handleToDateChange = date => {
        let hr = this.view.state.toDateTime.hour();
        let min = this.view.state.toDateTime.minutes();
        date.hours(hr);
        date.minutes(min);
        this.view.setState({ toDateTime: date });
    };

    handleToHourChange = (hour, minutes) => {
        const date = moment.utc(this.view.state.toDateTime);
        date.hour(hour);
        date.minutes(minutes);
        this.view.setState({
            toDateTime: moment.utc(date)
        });    
    };

    isAvailabilityTypeOneWay = (value) => {
        return value === 'oneway';
    }

    amendToDate = (availabilityType, date) => {
        if (this.isAvailabilityTypeOneWay(availabilityType)) {
            this.view.setState({ toDateTime: moment.utc(date) });
        } else {
            let hr = moment(this.view.state.toDateTime).hour();
            let min = moment(this.view.state.toDateTime).minutes();
            let tt = moment.utc(date).add(1, 'days');
            tt.hours(hr);
            tt.minutes(min);
            this.view.setState({ toDateTime: tt });
        }
    }

    submit = (e) => {
        let state = this.view.state;
        let fromDateTime = moment(state.fromDateTime).format(TRANSFER_SERVICE_DISTRIBUTION_FORMAT);
        let toDateTime = state.toDateTime ? moment(state.toDateTime).format(TRANSFER_SERVICE_DISTRIBUTION_FORMAT) : '';
        let req = {
            'fromDateTime': fromDateTime,
            'toDateTime': toDateTime,
            'transferType': state.transferType,
            'from': state.from,
            'to': state.to,
            'adults': state.rooms[0].adults,
            'kids': state.rooms[0].kids,
            'AssociatedOlympiaLocator': state.reservation,
        };
        this.view.setState({ loading: true, inputError: false });
        callAvailability(req).then(data => {
            this.view.setState({ loading: false });
            window.location.href = '/#/results/transfers/' + data.requestToken;
        }).catch(e => {
            this.view.setState({ loading: false });
            alert(e.message + '\n' + (e.detailedMessage || ''));
            //this.setState({ inputError: '<b>' + e.message + '</b><br />' + (e.detailedMessage || '') });
        });
    }

    getOriginZone = (origin) => {
        let code = origin ? origin.code : '';

        if (origin && origin.zone && origin.zone.code) {
            code = origin.zone.code;
        }
        return code;
    }


    handleAdultChange = (number, adults) => {
        let stateAdults = this.view.state.adults;
        stateAdults = adults;
        this.view.setState({ adults: stateAdults });
    };

    handleKidsChange = (number, kids) => {
        let stateKids = this.view.state.kids;
        stateKids = Array.from(Array(kids), x => ({ age: 0 }));
        this.view.setState({ kids: stateKids });
    };

    handleKidsAgeChange = (number, numberKid, age) => {
        let stateKids = this.view.state.kids;
        stateKids[numberKid].age = age;
        this.view.setState({ kids: stateKids });
    };

    /** 
     * Clear destination logic
     */

    clearDestinationFts = () => {
        if (this.componentDestination) {
            this.componentDestination.clear();
        }
    }

    originSelected = suggestion => {
        let prop = 'from';
        if (suggestion) {
            this.clearDestinationFts();
            let val = suggestion ? suggestion.formattedName : '';
            let thestate = { selectedSuggestion: suggestion };
            if (prop === undefined) {
                prop = 'value';
                thestate[prop] = val;
            } else {
                thestate[prop] = suggestion;
                thestate.value = val;
            }
            thestate['to'] = null;
            this.view.setState(thestate);
        } else {
            let thestate = { selectedSuggestion: null };
            thestate['from'] = null;
            thestate['to'] = null;
            this.clearDestinationFts();
            this.view.setState(thestate);
        }
    }

    destinationFTS = (comp) => {
        this.componentDestination = comp;
        //alert(comp);
    }
}
export default (SearchTransferController);


// WEBPACK FOOTER //
// ./src/components/SearchContent/Transfers/SearchTransferController.js